interface Cookies {
  set: (name: string, value: string, expiry?: string, path?: string, domain?: string, secure?: boolean, sameSite?: 'None') => void;
  remove: (name: string) => void;
  get: (name: string) => string | null | undefined;
}

declare global {
  interface Window {
    $cookies: Cookies;
  }
}

export default function useCookie() {

  function setCookie(name: string, token: string, expiry?: string, path?: string, secure?: boolean, sameSite?: 'None') {
    const isLocalhost = window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1');
    if (!isLocalhost) {
      // as an example for login.eagleeyenetworks.com the main domain is .eagleeyenetworks.com
      const mainDomain = window.location.hostname.split('.').slice(-2).join('.');
      window.$cookies.set(name, token, expiry, path, mainDomain, secure, sameSite);
    } else {
      window.$cookies.set(name, token, expiry);
    }
    
  }

  function removeCookie(name: string) {
    window.$cookies.remove(name);
  }

  function getCookie(name: string) {
    return window.$cookies.get(name) || null;
  }

  return {
    setCookie,
    getCookie,
    removeCookie
  };

}